import { getErrorMessage } from "../utils/commonUtils";
import { toast } from "react-toastify";
import {
  useInvOrderCreateMutation,
  useInvOrderListMutation,
  useInvOrdersMutation,
  useOrderStatusMasterMutation,
  useInvOrderByIdMutation,
  useGetOrderItemsMutation,
  useGetOrderItemsExportMutation,
  useInvOrderDeleteMutation,
  useInvOrderMarkCompleteMutation,
  usePurchaseOrderCreateMutation,
  useInvPurchaseOrderDeleteMutation,
  useInvOrderItemMarkCompleteMutation,
  useGetPurchaseOrderMutation,
  usePurchaseOrderTransmitMutation,
  usePurchaseOrderUpdateStatusMutation,
  useInvOrderUpdateMutation
} from "../redux/inventoryOrder/inventoryOrderApiSlice";

export default function useInventoryOrder() {
  const [InvOrderList, { isLoading: InvOrderListLoading }] =
    useInvOrderListMutation();
  const [orderStatusMaster, { isLoading: orderStatusMasterLoading }] =
    useOrderStatusMasterMutation();
  const [InvOrders, { isLoading: InvOrdersLoading }] = useInvOrdersMutation();
  const [InvOrderById, { isLoading: InvOrderByIdLoading }] =
    useInvOrderByIdMutation();
  const [invOrderCreate, { isLoading: invOrderCreateLoading }] =
    useInvOrderCreateMutation();
  const [getOrderItems, { isLoading: getOrderItemsLoading }] = useGetOrderItemsMutation();
  const [getOrderItemsExport, { isLoading: getOrderItemsExportLoading }] = useGetOrderItemsExportMutation();
  const [invPurchaseOrderDelete, { isLoading: invPurchaseOrderDeleteLoading }] = useInvPurchaseOrderDeleteMutation();
  const [invOrderMarkComplete, { isLoading: invOrderMarkCompleteLoading }] = useInvOrderMarkCompleteMutation();
  const [purchaseOrderCreate, { isLoading: purchaseOrderCreateLoading }] = usePurchaseOrderCreateMutation();
  const [getPurchaseOrder, { isLoading: getPurchaseOrderLoading }] = useGetPurchaseOrderMutation();
  const [invOrderDelete, { isLoading: invOrderDeleteLoading }] = useInvOrderDeleteMutation();
  const [invOrderItemMarkComplete, { isLoading: invOrderItemMarkCompleteLoading }] = useInvOrderItemMarkCompleteMutation();
  const [purchaseOrderTransmit, { isLoading: purchaseOrderTransmitLoading }] = usePurchaseOrderTransmitMutation();
  const [purchaseOrderUpdateStatus, { isLoading: purchaseOrderUpdateStatusLoading }] = usePurchaseOrderUpdateStatusMutation();
  const [invOrderUpdate, { isLoading: invOrderUpdateLoading }] = useInvOrderUpdateMutation();

  const orderStatusMasterAPI = async () => {
    try {
      const response: any = await orderStatusMaster({}).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const InvOrderCreateAPI = async (data: any) => {
    try {
      const response: any = await invOrderCreate(data).unwrap();
      toast.success("Order Created successfully.");
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const InvOrderListAPI = async (data: any) => {
    try {
      const response: any = await InvOrderList(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const InvOrdersAPI = async (data: any) => {
    try {
      const response: any = await InvOrders(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const InvOrderByIdAPI = async (data: any) => {
    try {
      const response: any = await InvOrderById(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const getOrderItemsAPI = async (data: any) => {
    try {
      const response: any = await getOrderItems(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const getOrderItemExportAPI = async (data: any) => {
    try {
      const response: any = await getOrderItemsExport(data).unwrap();
      toast.success("Success!. File downloaded successfully");
      return response;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const deleteInventoryPurchaseOrderAPI = async (data: any) => {
    try {
      const response = await invPurchaseOrderDelete(data).unwrap();
      toast.success("Inventory Order deleted successfully.");
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const completeInventoryOrderItemAPI = async (data: any) => {
    try {
      const response = await invOrderItemMarkComplete(data).unwrap();
      toast.success("Inventory Order Item complete successfully.");
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const getPurchaseOrderAPI = async (data: any) => {
    try {
      const response: any = await getPurchaseOrder(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const purchaseOrderCreateAPI = async (data: any) => {
    try {
      const response: any = await purchaseOrderCreate(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const deleteInventoryOrderAPI = async (data: any) => {
    try {
      const response = await invOrderDelete(data).unwrap();
      toast.success("Inventory Order Item deleted successfully.");
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const completeInventoryOrderAPI = async (data: any) => {
    try {
      const response = await invOrderMarkComplete(data).unwrap();
      toast.success("Inventory Order Item complete successfully.");
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const transmitPurchaseOrderAPI = async (data: any) => {
    try {
      const response: any = await purchaseOrderTransmit(data).unwrap();
      toast.success("Order transmitted successfully.");
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const updatePurchaseOrderStatusAPI = async (data: any) => {
    try {
      const response: any = await purchaseOrderUpdateStatus(data).unwrap();
      toast.success("Order status updated successfully.");
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const updateInventoryOrderAPI = async (data: any) => {
    try {
      const response: any = await invOrderUpdate(data).unwrap();
      toast.success("Inventory Order Item updated successfully.");
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  return {
    InvOrderListAPI,
    InvOrderListLoading,
    InvOrdersAPI,
    InvOrdersLoading,
    InvOrderCreateAPI,
    invOrderCreateLoading,
    orderStatusMasterAPI,
    orderStatusMasterLoading,
    InvOrderByIdAPI,
    InvOrderByIdLoading,
    getOrderItemsAPI,
    getOrderItemsLoading,
    getOrderItemExportAPI,
    getOrderItemsExportLoading,
    deleteInventoryPurchaseOrderAPI,
    invPurchaseOrderDeleteLoading,
    completeInventoryOrderAPI,
    invOrderMarkCompleteLoading,
    getPurchaseOrderAPI,
    getPurchaseOrderLoading,
    purchaseOrderCreateAPI,
    purchaseOrderCreateLoading,
    deleteInventoryOrderAPI,
    invOrderDeleteLoading,
    completeInventoryOrderItemAPI,
    invOrderItemMarkCompleteLoading,
    transmitPurchaseOrderAPI,
    purchaseOrderTransmitLoading,
    updatePurchaseOrderStatusAPI,
    purchaseOrderUpdateStatusLoading,
    updateInventoryOrderAPI,
    invOrderUpdateLoading
  };
}
